import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M2.5 12.5V3.5C2.5 2.94772 2.94771 2.5 3.5 2.5H12.5C13.0523 2.5 13.5 2.94772 13.5 3.5V12.5C13.5 13.0523 13.0523 13.5 12.5 13.5H3.5C2.94772 13.5 2.5 13.0523 2.5 12.5Z"
            fill="#B1D5F6"
            stroke="#3867A5"
            strokeLinecap="round"
        />
        <path
            d="M8 1.5H5C4.72386 1.5 4.5 1.72386 4.5 2V8.1C4.5 8.26481 4.68815 8.35889 4.82 8.26L6.38 7.09C6.45111 7.03667 6.54889 7.03667 6.62 7.09L8.18 8.26C8.31185 8.35889 8.5 8.26481 8.5 8.1V2C8.5 1.72386 8.27614 1.5 8 1.5Z"
            fill="#F2DE87"
            stroke="#BB9631"
            strokeLinecap="round"
        />
    </svg>
);

export default Icon;
